

export default function getProducts(project, austattung_produkt){

    const productList = [];

    let addDomoveaBasic = false;
    // const checkForDomoveaBasic = (project.selectedEquipment["tuerko-mobil"] === undefined || !Boolean(project.selectedEquipment["tuerko-mobil"]));

    project.floors.forEach(floor => {
        floor.rooms.forEach(room => {
            if(
                (room.selectedEquipment["heizen_fussbodenheizung"] !== undefined
                    && Boolean(room.selectedEquipment["heizen_fussbodenheizung"])) ||
                (room.selectedEquipment["smartphone"] !== undefined
                    && Boolean(room.selectedEquipment["smartphone"])) ||
                (room.selectedEquipment["sprachsteuerung"] !== undefined
                    && Boolean(room.selectedEquipment["sprachsteuerung"]))
            ){
                addDomoveaBasic = true;
            }
        })
    })
console.log('project projecttype', project.projectType, austattung_produkt["domovea-basic"], austattung_produkt["domovea-expert-tuer"])
    // easy bekommt immer, knx nur wenn smart heizung oder smart steuerung gecheckt ist
    if (project.projectType === 'easy') {
        productList.push({
            product: austattung_produkt["domovea-basic"], //["domovea-basic"],
            count: 1
        });
    } else {
        if (addDomoveaBasic) {
            productList.push({
                product: austattung_produkt["domovea-expert-tuer"], //["domovea-basic"],
                count: 1
            });
        }
    }
    // if(addDomoveaBasic){
    //     productList.push({
    //         product: austattung_produkt["domovea-expert-tuer"], //["domovea-basic"],
    //         count: 1
    //     });
    // }

    return productList;
}
